import { InfoIconWithTooltip, LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import theme from './ProjectLicenses.module.scss';
import React from 'react';
import { BygrProject, RubenProjectLicenseItemType, RubenProjectLicenseRenderedDto } from '@/types';
import { createRubenProjectLicense, getRubenProjectLicense, setRubenProjectLicenseItem } from '@/services/rubenLicense';
import { useAsyncStateWithIsLoading } from '@/utils/hooks';
import { AlertBanner, Card, SlideToggle } from '@ygtechnologies/rubus-ui';

interface ProjectLicensesRubenProps {
    project: BygrProject;
}

const ProjectLicensesRuben: React.FC<ProjectLicensesRubenProps> = (props) => {
    const [rubenLicense, , reloadRubenLicense, isLoadingRubenLicense] = useAsyncStateWithIsLoading(() => getRubenProjectLicense(props.project.id), [props], null);

    const handleLicenseToggle = async (checked: boolean, type: RubenProjectLicenseItemType) => {
        let license = rubenLicense; // This is a funcky way to handle the license, but it works.
        if (rubenLicense === null) {
            license = await createLicense();
        }

        await setRubenProjectLicenseItem(props.project.id, {
            projectLicenseId: license!.id,
            type: type,
            isActive: checked,
        });
        reloadRubenLicense();
    };

    const createLicense = async (): Promise<RubenProjectLicenseRenderedDto> => {
        const newLicense = await createRubenProjectLicense(props.project.id, {
            id: 0,
            projectId: props.project.id,
            projectName: props.project.name,
            profileLicenseId: 0,
            items: [],
        });

        return newLicense;
    };

    const isItemActive = (type: RubenProjectLicenseItemType) =>
        rubenLicense?.items.find((x) => x.type === type)?.isActive ?? false;

    return (
        <Card variant="flat">
            <h4 className={theme.cardTitle}>Ruben</h4>
            {isLoadingRubenLicense ? (
                <LoadingIndicator />
            ) : (
                <>
                    <AlertBanner type="info">
                        Remember to activate the profile license for Ruben case analytics in order for users to view the
                        analyzed cases.
                    </AlertBanner>
                    <div className={theme.licenseRow}>
                        <SlideToggle
                            checked={isItemActive(RubenProjectLicenseItemType.CaseAnalysis)}
                            onChange={(e) => handleLicenseToggle(e.target.checked, RubenProjectLicenseItemType.CaseAnalysis)}>
                            Ruben case analytics
                        </SlideToggle>
                        <InfoIconWithTooltip content="This activates Ruben analytics on cases created by buyers in this project. NOTE!! This will only run the analytics job on the project. For users to see the Ruben data, the profile they belong to needs to have an active" />
                    </div>
                    <div className={theme.licenseRow}>
                        <SlideToggle
                            checked={isItemActive(RubenProjectLicenseItemType.CaseEmail)}
                            onChange={(e) => handleLicenseToggle(e.target.checked, RubenProjectLicenseItemType.CaseEmail)}>
                            Case Inbox
                        </SlideToggle>
                        <InfoIconWithTooltip content="This activates the Case Inbox settings in the project, and gives admins access to setup and handle incoming mail. This also runs the Ruben jobs for auto creating cases from mail." />
                    </div>
                </>
            )}
        </Card>
    );
};

export default ProjectLicensesRuben;
